module.exports = __webpack_public_path__ + "static/media/screen-individual-02.99cb4627.jpg";